import React, { useState } from 'react'


import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'

import MenuButtonItems from './MenuButtonItems'

const useStyles = makeStyles(theme => ({
  
}))

const IconMenuButton = ({
  buttonProps,
  items,
  children,
}) => {
  const classes = useStyles()
  const [ anchorEl, setAnchorEl ] = useState(null)

  const handleMenu = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <div className={ classes.root }>
      <IconButton
        onClick={ handleMenu }
        {...buttonProps}
      >
        { children }
      </IconButton>
      <MenuButtonItems
        anchorEl={ anchorEl }
        items={ items }
        onClose={ handleClose }
      />        
    </div>
  )
}

export default IconMenuButton